import { useEffect, useRef } from 'react'

interface BotaoGoogleProps {
  clientId: string
  onCredential: (idToken: string) => void
  texto?: 'signin_with' | 'signup_with' | 'continue_with'
}

interface GoogleIdentity {
  accounts: {
    id: {
      initialize: (config: { client_id: string; callback: (r: { credential: string }) => void }) => void
      renderButton: (el: HTMLElement, opcoes: Record<string, string | number>) => void
    }
  }
}

const SCRIPT_URL = 'https://accounts.google.com/gsi/client'

/** Botão oficial do Google Identity Services: o token vem assinado e a API valida. */
export function BotaoGoogle({ clientId, onCredential, texto = 'continue_with' }: BotaoGoogleProps) {
  const alvo = useRef<HTMLDivElement>(null)
  const callbackRef = useRef(onCredential)
  useEffect(() => { callbackRef.current = onCredential }, [onCredential])

  useEffect(() => {
    let cancelado = false

    async function carregar() {
      if (!document.querySelector(`script[src="${SCRIPT_URL}"]`)) {
        await new Promise<void>((resolve, reject) => {
          const script = document.createElement('script')
          script.src = SCRIPT_URL
          script.async = true
          script.onload = () => resolve()
          script.onerror = () => reject(new Error('falha ao carregar o Google'))
          document.head.appendChild(script)
        }).catch(() => undefined)
      }

      const google = (window as unknown as { google?: GoogleIdentity }).google
      if (cancelado || !google || !alvo.current) return

      google.accounts.id.initialize({
        client_id: clientId,
        callback: (resposta) => callbackRef.current(resposta.credential),
      })

      google.accounts.id.renderButton(alvo.current, {
        type: 'standard',
        theme: 'filled_black',
        size: 'large',
        text: texto,
        shape: 'rectangular',
        width: 320,
        locale: 'pt-BR',
      })
    }

    carregar()
    return () => { cancelado = true }
  }, [clientId, texto])

  return <div ref={alvo} className="flex justify-center" />
}
